export default __webpack_public_path__ + "static/10-d3259f1937de2824f4efa530e293c872.png";